import { axios, researchAxios } from '@/utils/request';

let Api = {
  create_question: '/create_question', // 新增对话
  create_question_scholar: '/api/questions/create-question-scholar', // 新增对话-专家查询
  create_question_generate: '/api/questions/create-question-generate', // 新增对话-技术问答
  get_question_list: '/get_question_list', // 获取历史对话列表
  get_history_chat_detail: '/get_history', // 根据id获取历史会话详情
  // scholar_query: 'scholar_query', // 专家查询Api
  // generate: '/generate', // 技术问答Api
  // generate_survey: '/generate_survey', // 文献调研Api
  scholar_query_stop: 'scholar_query_stop', // 终止专家查询
  generate_stop: '/generate_stop', // 终止技术问答
  generate_survey_stop: '/create_survey_stop', // 终止文献调研
  download_by_task: '/download/by-task', // 下载生成的文献
  delete_question: '/delete_question', // 删除会话
  recommend_question: '/recommend_question', // 专家查询-推问题题列表

  translate: '/translate', // 翻译

  matchtitle: '/matchtitle', // 根据论文标题和url查询论文详情

  find_paper_list: '/find_paper_list', // 首页最新文献列表

  scholar_query_start: '/scholar_query/start', // 启动生成任务（获取 SessionID）
  getScholarTaskStatus: '/scholar/task/status', // 查询任务状态
};

/**
 * 新增对话 传入用户id 返回会话id
 * @param params
 * @returns {*}
 */
export const createQuestionApi = (params) => {
  return researchAxios.post(Api.create_question, params);
};

// 新增对话-专家查询
export const createQuestionScholarApi = (params) => {
  return axios.post(Api.create_question_scholar, params);
}

// 新增对话-技术问答
export const createQuestionGenerateApi = (params) => {
  return axios.post(Api.create_question_generate, params);
}

// 获取侧边栏历史会话列表
export const getQuestionListApi = (params) => {
  return researchAxios.post(Api.get_question_list, params);
};

// 根据id获取历史会话详情
export const getHistoryChatDetailApi = (params) => {
  return researchAxios.post(Api.get_history_chat_detail, params);
};

// // 技术问答Api
// export const generateApi = (params) => {
//   return researchAxios.post(Api.generate, params);
// };
//
// // 文献调研Api
// export const generateSurveyApi = (params) => {
//   return researchAxios.post(Api.generate_survey, params);
// };

// 下载生成的文献
export const downloadLiteratureApi = (params) => {
  return researchAxios.get(Api.download_by_task + '/' + params.id, {
    responseType: 'blob',
  });
};

// 根据id删除会话
export const deleteQuestionApi = (params) => {
  return researchAxios.post(Api.delete_question, params);
};

// 翻译
export const translateApi = (params) => {
  return researchAxios.post(Api.translate, params);
};

// 根据论文标题和url查询论文详情
export const matchtitleApi = (params) => {
  return researchAxios.post(Api.matchtitle, params);
};

// 终止专家查询
export const scholarQueryStopApi = (params) => {
  return researchAxios.post(Api.scholar_query_stop, params);
};

// 终止技术问答
export const generateStopApi = (params) => {
  return researchAxios.post(Api.generate_stop, params);
};

// 终止文献调研
export const generateSurveyStopApi = (params) => {
  return researchAxios.post(Api.generate_survey_stop, params);
};

// 专家查询-推问题题列表
export const getRecommendQuestionApi = (params) => {
  return researchAxios.post(Api.recommend_question, params);
};

// 首页最新文献列表
export const findPaperListApi = (params) => {
  return researchAxios.post(Api.find_paper_list, params);
};


// 专家查询启动生成任务（获取 SessionID）
export const scholarQueryStartApi = (params) => {
  return researchAxios.post(Api.scholar_query_start, params);
};

// 专家查询查询任务状态
export const getScholarTaskStatusApi = (params) => {
  return researchAxios.get(Api.getScholarTaskStatus, { params });
};
